import Vue from 'vue'
import 'vue-material-design-icons/styles.css'
import MdCompassOutline from 'vue-material-design-icons/CompassOutline.vue'
import MdTable from 'vue-material-design-icons/Table.vue'
import MdMenu from 'vue-material-design-icons/Menu.vue'
import MdFullscreen from 'vue-material-design-icons/Fullscreen.vue'
import MdLifebuoy from 'vue-material-design-icons/Lifebuoy.vue'
import MdBell from 'vue-material-design-icons/Bell.vue'
import MdSettings from 'vue-material-design-icons/Cog.vue'
import MdCalendar from 'vue-material-design-icons/Calendar.vue'
import MdGraphOutline from 'vue-material-design-icons/GraphOutline.vue'
import MdBookOpenOutline from 'vue-material-design-icons/BookOpenOutline.vue'
import MdFlashOutline from 'vue-material-design-icons/FlashOutline.vue'
import MdArrowTopLeftBottomRight from 'vue-material-design-icons/ArrowTopLeftBottomRight.vue'
import MdFileDocument from 'vue-material-design-icons/FileDocument.vue'
import MdClock from 'vue-material-design-icons/Clock.vue'

Vue.component('MdCompassOutline', MdCompassOutline)
Vue.component('MdTable', MdTable)
Vue.component('MdMenu', MdMenu)
Vue.component('MdFullscreen', MdFullscreen)
Vue.component('MdLifebuoy', MdLifebuoy)
Vue.component('MdBell', MdBell)
Vue.component('MdSettings', MdSettings)
Vue.component('MdCalendar', MdCalendar)
Vue.component('MdGraphOutline', MdGraphOutline)
Vue.component('MdBookOpenOutline', MdBookOpenOutline)
Vue.component('MdFlashOutline', MdFlashOutline)
Vue.component('MdArrowTopLeftBottomRight', MdArrowTopLeftBottomRight)
Vue.component('MdFileDocument', MdFileDocument)
Vue.component('MdClock', MdClock)
